import React, { useState } from 'react';

// Use a fixed timestamp that will be the same on server and client
const LAST_UPDATE_DATE = '2024-03-20T00:00:00Z'; // Use UTC timestamp

const DataDisclosure: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  // Parse the fixed date string and force UTC
  const date = new Date(LAST_UPDATE_DATE);
  const formattedDate = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'UTC' // Force UTC timezone
  }).format(date);

  return (
    <div className="bg-gray-100 border-t border-gray-200 py-3 text-sm text-gray-600">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div>
            <button 
              onClick={() => setIsOpen(!isOpen)}
              className="text-blue-600 hover:underline flex items-center"
            >
              Data Sources & Privacy Information
              <svg 
                className={`ml-1 w-4 h-4 transition-transform ${isOpen ? 'transform rotate-180' : ''}`} 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          </div>
          <div className="mt-2 md:mt-0 text-xs">
            <span>Data last updated: {formattedDate}</span>
          </div>
        </div>
        
        {isOpen && (
          <div className="mt-4 bg-white p-4 rounded-lg shadow-md">
            <h3 className="font-semibold mb-2">About Our Data</h3>
            <p className="mb-2">
              The information provided on this site is collected from various public sources and business listings. 
              We make efforts to ensure accuracy but cannot guarantee the correctness of all information.
            </p>
            
            <h4 className="font-semibold mb-1 mt-3">Data Sources:</h4>
            <ul className="list-disc pl-5 mb-3 text-sm">
              <li>Business directories and public listings</li>
              <li>Verified mechanic submissions</li>
              <li>Customer reviews from multiple platforms</li>
            </ul>
            
            <h4 className="font-semibold mb-1 mt-3">Reviews:</h4>
            <p className="text-sm mb-3">
              Reviews displayed on this site are aggregated from multiple sources including 
              public review platforms. Reviews are displayed for informational purposes and
              are not endorsed by this website. Each review belongs to its original author.
            </p>
            
            <h4 className="font-semibold mb-1 mt-3">Maps:</h4>
            <p className="text-sm mb-3">
              Map data ©{new Date().getFullYear()} provided by Google Maps Platform and OpenStreetMap contributors.
              Usage is subject to Google Maps/Google Earth Additional Terms of Service and OpenStreetMap licensing terms.
            </p>
            
            <h4 className="font-semibold mb-1 mt-3">Privacy Information:</h4>
            <p className="text-sm mb-1">
              When you use our website, we may collect certain information about your device and usage patterns.
              This information helps us improve our services and provide a better user experience.
            </p>
            <p className="text-sm mb-3">
              Your location data is only collected with your explicit consent and is not stored permanently or 
              shared with third parties for advertising purposes.
            </p>
            
            <div className="flex justify-end mt-4">
              <button 
                onClick={() => setIsOpen(false)}
                className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300 text-sm"
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DataDisclosure; 